import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import "./permission"

Vue.config.productionTip = false
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import "./mock/index"
import Mock from "mockjs";
// Mock.XHR.prototype.withCredentials = true;
import VueAMap from "vue-amap";
Vue.use(VueAMap);
// 初始化vue-amap
VueAMap.initAMapApiLoader({
  key: "024c8848ec545823dda232768a1cd781", // 这里写你申请的高德地图的key
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor'],   //插件
  v: "1.4.4",  //版本号，默认高德sdk版本为1.4.4，可自行修改
  uiVersion: '1.0.11' // 版本号
});
// AmapVue.config.version = '2.0';
// AmapVue.config.key = "024c8848ec545823dda232768a1cd781"

// AmapVue.config.plugins = <never[]>['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor','AMap.AMapUI'
// ];
// Vue.use(AmapVue);
Vue.use(ElementUI);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
